/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const MoneyTime: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <g clipPath='url(#clip0_20400_917)'>
      <path
        d='M17 16.0001C14.049 16.0001 11.597 15.3611 10 14.2881C10 15.0341 10 15.5261 10 16.0001C10 17.6571 13.134 19.0001 17 19.0001C20.866 19.0001 24 17.6571 24 16.0001C24 15.5261 24 15.0341 24 14.2881C22.403 15.3611 19.951 16.0001 17 16.0001Z'
        fill='currentColor'
      />
      <path
        d='M17 21.0001C14.049 21.0001 11.597 20.3611 10 19.2881C10 20.0341 10 20.5261 10 21.0001C10 22.6571 13.134 24.0001 17 24.0001C20.866 24.0001 24 22.6571 24 21.0001C24 20.5261 24 20.0341 24 19.2881C22.403 20.3611 19.951 21.0001 17 21.0001Z'
        fill='currentColor'
      />
      <path d='M9 9H4V7H7V4H9V9Z' fill='currentColor' />
      <path d='M17 14C20.866 14 24 12.6569 24 11C24 9.34315 20.866 8 17 8C13.134 8 10 9.34315 10 11C10 12.6569 13.134 14 17 14Z' fill='currentColor' />
      <path
        d='M8 14C4.691 14 2 11.309 2 8C2 4.691 4.691 2 8 2C10.636 2 13.001 3.763 13.752 6.286L13.754 6.293C14.386 6.173 15.057 6.088 15.765 6.043L15.668 5.715C14.667 2.351 11.514 0 8 0C3.589 0 0 3.589 0 8C0 12.411 3.589 16 8 16V14Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_20400_917'>
        <rect width='24' height='24' fill='currentColor' />
      </clipPath>
    </defs>
  </React.Fragment>
)
